import type { Component, Entity, EntityClass } from '../../..';
import type { RemovedUndefined } from '..';
import type { UnionToIntersection } from './UnionToIntersection';

export type ComponentsObject = { [key: string]: Component };

export interface WithStaticName<T = any> {
  NAME: string;
  new (...args: any[]): T;
}

/** Converts and array of components into an object where its keys is the NAME and the value is the instance of the class */
export type KeyByInstance<A extends WithStaticName[]> = UnionToIntersection<
  A extends (infer B)[]
    ? B extends WithStaticName
      ? { [key in B['NAME']]: InstanceType<B> }
      : never
    : never
>;

/** Converts an array of components into an object where its keys is the NAME and the value is the options passed into the `init` function */
export type KeyByComponent<
  A extends Record<string, InstanceType<WithStaticName>>,
> = Partial<RemovedUndefined<{ [P in keyof A]: Parameters<A[P]['init']>[0] }>>;

/** Takes an entity class and converts it into its instance type */
export type EntityType<T extends EntityClass> = InstanceType<T>;

/** Takes an array of components and a base class and creates a new class definition */
export type EntityClassType<
  C extends WithStaticName[],
  PC extends WithStaticName[],
  B extends Entity = Entity,
> = EntityClass<C, PC, B['c'], Entity<C, PC, {}> & B>;
